import React, { useEffect, useState, useRef } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { PlusCircleFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/CustomButton";
import { Modal } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import { postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import CustomToast from "../../components/CustomToast/CustomToast";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import GroupTable from "./grouptable";

const Group: React.FunctionComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [excelFile, setExcelFile] = useState<any>(null);
  const [isGroupDataFetched, setIsGroupDataFetched] = useState(false)
  const dispatch = useAppDispatch();

  const handleAddGroup = () => {
    navigate("/group/create");
  };

  const handleShowModal = () => {
    setExcelFile(null)
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleDownload = () => {
    const filePath = '/files/Import_Group_Sample.xlsx'
    
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'Import_Group_Sample.xlsx'; 
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
  }

  const handleFileChange = (ev: any)=>{
    const excelFile = ev.target.files[0]

    if(excelFile && excelFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
      dispatch(showToast("Please upload an excel file with .xlsx extension"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return
   }

      setExcelFile(excelFile)
  }

  const handleFileUpload = async (ev: any)=>{
      ev.preventDefault()
      if(!excelFile){
        dispatch(showToast("Please upload excel file"));
        setTimeout(() => dispatch(hideToast()), 3000);
         return
      }

      const formData = new FormData();
      formData.append('excelFile', excelFile)

      try {
        const response = await postMultipartDetails(APIList.IMPORT_GROUP, formData)

        console.log(response)
        if(response.status === "Failed"){
          dispatch(showToast("Invalid Excel."));
       setTimeout(() => dispatch(hideToast()), 3000);
          return
        }

     else if(response.statusCode === 200){
          // dispatch(showToast("Uploaded groups successfully."));
          // setTimeout(() => dispatch(hideToast()), 3000);
          const { totalRecord, insertedGroupCount, insertedAttendeeCount, updatedCount, invalidDetails } = response.data;

          let successMessage = "";
          let errorMessage = "";
        
          if (totalRecord === 0) {
            errorMessage = "Invalid Excel.";
          } else {
            if (insertedGroupCount > 0) {
              successMessage += `${insertedGroupCount} group(s) successfully added.\n`;
            }
        
            if (insertedAttendeeCount > 0) {
              successMessage += `${insertedAttendeeCount} attendee(s) successfully added.\n`;
            }
        
            if (updatedCount > 0) {
              successMessage += `${updatedCount} record(s) updated.\n`;
            }
        
            if (invalidDetails && invalidDetails.length > 0) {
              errorMessage += "The following records contain errors:\n";
              invalidDetails.forEach((detail:string) => {
                errorMessage += `${detail}\n`;
              });
            }
        
            if (insertedGroupCount === 0 && insertedAttendeeCount === 0 && updatedCount === 0 && invalidDetails.length === 0) {
              errorMessage = "No records were inserted or updated.";
            }
          }
        
          if (successMessage) {
            dispatch(showToast(successMessage));
          }
        
          if (errorMessage) {
            dispatch(showToast(errorMessage));
          }
          
          setTimeout(() => dispatch(hideToast()), 10000);
        }
        else{
          // const errorMessage = response.data.invalidDetails.reduce((acc:string, error:string, index:number) => {
          //   return acc + (index > 0 ? '\n' : '') + error;
          // }, '');
          // console.log(errorMessage)
          dispatch(showToast("Unable to add groups"));
          setTimeout(() => dispatch(hideToast()), 3000);
        }
        
        setIsGroupDataFetched(!isGroupDataFetched)
        handleCloseModal()
      } catch (error) {
        console.log(error)
        dispatch(showToast("Some error occured while uploading file, please try again later"));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
  }

  const buttons = [
    {
      label: "Import Group",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: handleShowModal,
    },
    {
      label: "Add New Group",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: handleAddGroup,
    },
  ];

  return (
    <LayoutContainer title={"Group Master List"}>
      <CustomToast />
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{"Import Group - xlsx"}</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
        <div className="font-14">
        <p>Use this facility to upload multiple Group in one go. Upload file type should be similar to downloaded sample. Download sample template by clicking on the 'Download Sample File'.</p>
        <p><strong>Mandatory fields:</strong> Group Name, Emp Code</p>
        <p>Lets say from an upload file of 200 records, if only 150 are valid and 50 have issues, system will accept the valid 150 records and show appropriate errors for the 50 ones. You can fix the issues for those 50 records and then use the same 'Upload with over-write' facility (without removing valid 150 records from the file) to upload again. System will over-write the 150 valid records again without expecting users to remove them from the upload file.</p>
        <p>Note: Upload may take some time if the record size is big.</p>

        <form onSubmit={handleFileUpload}>
          
          <div className="mb-4">
            <input type="file" name="groupExcelFile" accept=".xlsx, .xls"  id="groupExcelFile" onChange={handleFileChange}/>
          </div>
        
              <div className="mb-2">
           <CustomButton theme="yellow" type="button" size="md" onClick={handleDownload}>
           <span className="d-flex align-items-center justify-content-center gap-2">Download Sample File <FaDownload /></span>            
           </CustomButton>   
            </div>
            <div>
           <CustomButton theme="yellow" type="submit" size="md">
            Upload With Overwrite
            </CustomButton>   
            </div>
            </form>

        </div>
        </Modal.Body>
        </Modal>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon  fa fa-list"></i>
          Group Master List
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div className="mx-2">
        <GroupTable isGroupDataFetched={isGroupDataFetched} />
      </div>
    </LayoutContainer>
  );
};

export default Group;
